/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedUserRoleListResponse } from '../types/PaginatedUserRoleList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type UserRolesListRequest = {} | null | undefined;
export type UserRolesListResponse = PaginatedUserRoleListResponse;

export type UserRolesListQuery = {
  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;
};

/**
 * GET /dmx-server/user_roles/
 *
 * ```yaml
 * operationId: user_roles_list
 * tags:
 *   - user_roles
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedUserRoleList'
 *     description: ''
 * ```
 */
export const userRolesListOperation = (rest?: UserRolesListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/user_roles/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/user_roles/' };
  };

/**
 * GET /dmx-server/user_roles/
 *
 * ```yaml
 * operationId: user_roles_list
 * tags:
 *   - user_roles
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedUserRoleList'
 *     description: ''
 * ```
 */
export const userRolesList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: UserRolesListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedUserRoleListResponse>> => {
  const operation = userRolesListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/user_roles/
 */
export const useUserRolesListResource = (
  query: UserRolesListQuery | null,
  useCached?: boolean,
): UseResource<UserRolesListResponse> => {
  return useResource<UserRolesListResponse>({
    path: query === null ? null : userRolesListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
